import React, { useState } from "react";
import QuietVideoPlayer from "../shared/QuietVideoPlayer.jsx";
import { MADE_BY_VIDEO_TABS } from "../shared/heroVideo.js";

const MadeByRoofersSection = ({ onOpenModal }) => {
  const [activeTabId, setActiveTabId] = useState(MADE_BY_VIDEO_TABS[0].id);
  const activeTab = MADE_BY_VIDEO_TABS.find((tab) => tab.id === activeTabId) ?? MADE_BY_VIDEO_TABS[0];

  return (
    <section className="cursor-section roofing-made-by" data-testid="roofing-made-by-section">
      <div className="cursor-container roofing-made-by-inner">
        <h2 className="roofing-made-by-title" data-testid="roofing-made-by-headline">
          Made by <span className="roofing-made-by-gain">Roofers</span>, for{" "}
          <span className="roofing-made-by-gain">Roofers</span>.
        </h2>
        <p className="roofing-made-by-body" data-testid="roofing-made-by-body">
          We didn&apos;t build this in an office in California. We built it on real job sites
          because we were tired of paying Google $150 per lead, only to lose them to competitors
          while we were up on a roof or driving between sites.
        </p>

        <div
          className="roofing-made-by-tabs"
          role="tablist"
          aria-label="Video demos"
          data-testid="roofing-made-by-tabs"
        >
          {MADE_BY_VIDEO_TABS.map((tab) => {
            const selected = tab.id === activeTab.id;
            return (
              <button
                key={tab.id}
                type="button"
                role="tab"
                id={`roofing-made-by-tab-${tab.id}`}
                aria-selected={selected}
                aria-controls={`roofing-made-by-panel-${tab.id}`}
                tabIndex={selected ? 0 : -1}
                className={`roofing-made-by-tab${selected ? " is-active" : ""}`}
                onClick={() => setActiveTabId(tab.id)}
                data-testid={`roofing-made-by-tab-${tab.id}`}
              >
                <span className="roofing-made-by-tab-label">{tab.label}</span>
                {tab.subtitle ? (
                  <span className="roofing-made-by-tab-subtitle">{tab.subtitle}</span>
                ) : null}
              </button>
            );
          })}
        </div>

        <div
          role="tabpanel"
          id={`roofing-made-by-panel-${activeTab.id}`}
          aria-labelledby={`roofing-made-by-tab-${activeTab.id}`}
          data-testid={`roofing-made-by-panel-${activeTab.id}`}
        >
          <QuietVideoPlayer
            key={activeTab.id}
            src={activeTab.src}
            poster={activeTab.poster}
            chromeTitle={activeTab.chromeTitle}
            playLabel={activeTab.playLabel}
          />
        </div>

        <div className="roofing-made-by-cta-block">
          <button
            type="button"
            className="roofing-made-by-cta"
            onClick={onOpenModal}
            data-testid="roofing-made-by-cta"
          >
            <span>Hire Digital Employee - Ready in 12 Mins</span>
            <span aria-hidden="true"> ↗</span>
          </button>
          <p className="roofing-made-by-cta-caption" data-testid="roofing-made-by-cta-caption">
            Zero technical setup required • 14 days free
          </p>
        </div>
      </div>
    </section>
  );
};

export default MadeByRoofersSection;
